import LocalizedMessage from '../common/LocalizedMessage';
import React, { useState } from "react";
import PropTypes from "prop-types";
import Input from "../common/Input";
import { STATUS } from "../common/Const";
import API from "../../services/UserService";
import { useTranslation } from 'react-i18next';

const shortPasswordMessage = "Hasło musi mieć co najmniej 8 znaków.";

function PasswordResetConfirm({ match, history }) {
  const { t: tr } = useTranslation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [status, setStatus] = useState(STATUS.IDLE);

  const handleChange = (event) => {
    setPassword(event.target.value);
    if (event.target.value.length >= 8) {
      setError("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setStatus(STATUS.SUBMITTING);

    if (password.length < 8) {
      setError(shortPasswordMessage);
      setStatus(STATUS.SUBMITTED);
      return;
    }

    API.confirmPasswordReset(match.params.token, password)
      .then((response) => {
        history.push("/manage", {
          passwordResetMessage: response && response.message ? response.message : tr("auth:passwordChanged"),
        });
      })
      .catch((apiError) => {
        setError(apiError.message || tr("auth:resetExpired"));
        setStatus(STATUS.SUBMITTED);
      });
  };

  return (
    <div className="quiz-text auth-form-page">
      <h2><strong>{tr("auth:setPassword")}</strong></h2>
      {error && <div className="alert alert-danger" role="alert"><LocalizedMessage isError value={error} /></div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label={tr("auth:newPassword")}
              type="password"
              name="password"
              value={password}
              error={error}
              placeholder={tr("auth:newPassword")}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 mb-2">
            <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={status === STATUS.SUBMITTING}>{tr("auth:changePassword")}</button>
          </div>
        </div>
      </form>
    </div>
  );
}

PasswordResetConfirm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default PasswordResetConfirm;
